import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  OrganizationsState,
  OrganizationType,
} from "../types/organizationsTypes.tsx";
import { fetchOrganizationsList } from "../thunks/organizationsThunk.tsx";
import { getStorageName } from "../../helpers/storageName/storageName.ts";

const initialState: OrganizationsState = {
  isLoadingOrganizationsList: false,
  organizationsList: null,
  currentOrganization: null,
};

export const organizationsSlice = createSlice({
  name: "organizations",
  initialState,
  reducers: {
    setCurrentOrganization: (state, action) => {
      state.currentOrganization = action.payload;
    },
    setNewCurrentOrganization: (state, action) => {
      if (action.payload) {
        localStorage.setItem(
          getStorageName.currentOrganization,
          action.payload,
        );
        state.currentOrganization = action.payload;
      } else {
        localStorage.removeItem(getStorageName.currentOrganization);
        state.currentOrganization = null;
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchOrganizationsList.pending, (state) => {
      state.isLoadingOrganizationsList = true;
    });
    builder.addCase(
      fetchOrganizationsList.fulfilled,
      (state, action: PayloadAction<OrganizationType[]>) => {
        state.isLoadingOrganizationsList = false;
        state.organizationsList = action.payload;
      },
    );
    builder.addCase(fetchOrganizationsList.rejected, (state) => {
      state.isLoadingOrganizationsList = false;
    });
  },
});

export const { setNewCurrentOrganization, setCurrentOrganization } =
  organizationsSlice.actions;
